const DATA = ['All', 'Vietnam', 'Myanmar', 'Cambodia', 'Thai/Laos', 'Indonesia']

export default DATA
